import type { Config } from 'tailwindcss';

const config: Config = {
  content: [
    './lib/**/*.{js,ts,jsx,tsx,mdx}',
    './components/**/*.{js,ts,jsx,tsx,mdx}',
    './app/**/*.{js,ts,jsx,tsx,mdx}',
  ],
  theme: {
    screens: {
      'sm': '376px',
      // => @media (min-width: 376px) { ... }
      'md': '768px',
      // => @media (min-width: 768px) { ... }
      'lg': '1200px',
      // => @media (min-width: 1200px) { ... }
    },
    boxShadow: {
      'sm': '0px 2px 4px 0px rgba(0, 0, 0, 0.10)',
      'md': '0px 4px 10px 0px rgba(0, 0, 0, 0.10)',
    },
    extend: {
      width: {
        'sidebar': '360px',
      },
      padding: {
        '18px': '18px',
        'button': 'calc(2rem - 2px)',
      },
      variants: {
        padding: ['responsive', 'hover', 'focus'],
      },
      backgroundImage: {
        'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
        'gradient-conic':
          'conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))',
        'gr-purple-orange':
          'linear-gradient(to right, #E4D1F1, #F7CBC6, #EFBD91)',
        'logo': "url('/background.png')",
      },
      backgroundPosition: {
        'top-custom': 'center top 15%',
      },
      fontFamily: {
        sans: ['PT Sans', 'sans-serif'],
        indie: ['Indie Flower'],
        hanken: ['var(--font-hanken)'],
      },
      fontSize: {
        'xs': '0.5625rem',
        'sm': '0.875rem',
        'base': '1.000rem',
        'md': '1.125rem',
        'xl': '1.250rem',
        '2xl': '1.5rem',
        '3xl': '1.75rem',
        '4xl': '2rem',
        '6xl': '4rem',
      },
      colors: {
        'dark': '#000000',
        'app-background': '#DAD2E0',
        'purple-dark': '#210832',
        'purple-light': '#CDC5D7',
        'purple': '#756783',
        'zoc-orange': '#FC4837',
        'red': '#ff0000',
        'disbled-background': '#eeeeee',
        'disabled-text': '#616161',
        'focus-blue': '#0A84FF',
        'hover-purple': '#4C2566',
        //todo remove all colors from above
        'white': '#ffffff',
        'purple1': '#F4EAFF',
        'purple2': '#D5ABFF',
        'purple3': '#CA96FF',
        'purple4': '#CA96FF',
        'purple5': '#952DFE',
        'purple6': '#7724CB',
        'purple7': '#4B177F',
        'purple8': '#3C1266',
        'purple9': '#1E0933',
        'grey1': '#F5F5F5',
        'grey2': '#EBEBEB',
        'grey3': '#E0E0E0',
        'grey4': '#D6D6D6',
        'grey5': '#CCCCCC',
        'grey6': '#737373',
        'greyPurple': '#795F89',
        'lightOrange': '#FF862E',
        'orange': '#FC4837',
        'teal': '#00C1BA',
      },
      letterSpacing: {
        widest: '0.125rem',
        wide: '0.0625rem',
      },
      boxShadow: {
        input: '0px 2px 0px 0px #E0E0E0',
      },
    },
  },
};
export default config;
